export default __webpack_public_path__ + "dist/images/DreamworksNew-c44c83fed800c3e4c15581d231bf4cc3.svg";